import { Module } from 'vuex';

import { CourseVersion, VersionState, RootState, Nullable } from 'frontend/types';

interface CourseVersionState {
  courseVersions: Nullable<CourseVersion[]>;
}

function isActive({ state }: CourseVersion): boolean {
  return [
    VersionState.DRAFT,
    VersionState.CANDIDATE,
    VersionState.MAIN,
    VersionState.LEGACY,
  ].includes(state);
}

const courseVersionsModule: Module<CourseVersionState, RootState> = {
  namespaced: true,
  state: {
    courseVersions: [],
  },
  getters: {
    abandonedCourseVersions({ courseVersions }: CourseVersionState): CourseVersion[] {
      if (courseVersions === null) {
        return [];
      }

      return courseVersions.filter(version => !isActive(version));
    },
    activeCourseVersions({ courseVersions }: CourseVersionState): CourseVersion[] {
      if (courseVersions === null) {
        return [];
      }

      return courseVersions.filter(isActive);
    },
  },
  mutations: {
    setValue(state, versions: CourseVersion[] | null): void {
      state.courseVersions = versions;
    },
  },
  actions: {},
};

export default courseVersionsModule;
